var map = {
	"./images/bm-certification-logo.png": 1885,
	"./images/bmc-logo.png": 6793,
	"./images/card-amazon-pledge.jpg": 792,
	"./images/card-becoming-certification-body.jpg": 2722,
	"./images/card-becoming-certified.jpg": 4862,
	"./images/card-caterogy-expension.jpg": 2796,
	"./images/card-join-comittee.jpg": 1565,
	"./images/card-provide-data.jpg": 704,
	"./images/cls-logo.png": 7415,
	"./images/durable-image.jpg": 4238,
	"./images/durable-image2.jpg": 7382,
	"./images/favicon/apple-touch-icon.png": 3332,
	"./images/favicon/favicon-96x96.png": 7531,
	"./images/favicon/favicon.ico": 7892,
	"./images/favicon/favicon.svg": 4641,
	"./images/favicon/web-app-manifest-192x192.png": 2253,
	"./images/favicon/web-app-manifest-512x512.png": 1469,
	"./images/featured-wrap.jpg": 9092,
	"./images/hero-standards-durable.jpg": 8604,
	"./images/hero-standards-preloved.jpg": 4072,
	"./images/hero-standards-refillable.jpg": 7329,
	"./images/hero-standards-reusable.jpg": 9642,
	"./images/logo/amazon-logo.png": 4463,
	"./images/logo/emf-logo.png": 2011,
	"./images/logo/forest.svg": 503,
	"./images/logo/greencircle-logo.png": 9260,
	"./images/logo/nqa-logo.png": 9723,
	"./images/logo/nsf-logo.png": 4504,
	"./images/logo/nsf-logo2.png": 6008,
	"./images/logo/usb-logo.png": 1341,
	"./images/logo/white.svg": 5691,
	"./images/page-header-homepage.jpg": 6745,
	"./images/page-header-process.jpg": 3466,
	"./images/preloved-image.jpg": 6090,
	"./images/preloved_certified.svg": 9231,
	"./images/preloved_durable.svg": 5237,
	"./images/preloved_refillable.svg": 8524,
	"./images/preloved_reusable.svg": 3775,
	"./images/refillable-image.jpg": 2267,
	"./images/reusable-image.jpg": 5352,
	"./images/svg/forest-green-50-caret.svg": 6756,
	"./images/svg/forest-green-caret.svg": 1286,
	"./images/svg/menu-burger-opened.svg": 8864,
	"./images/svg/product-list.svg": 6871,
	"./images/svg/required.svg": 5758,
	"./images/svg/social-instagram.svg": 8947,
	"./images/svg/social-linkedin.svg": 2671,
	"./images/svg/social-x-twitter.svg": 4069,
	"./images/svg/social-youtube.svg": 6452,
	"./images/vibrant-green-arrow-down.svg": 485,
	"./images/wp-login.png": 8930,
	"./images/wp-login@2x.png": 6514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4283;